import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { Star } from "lucide-react";

import Modal from "react-bootstrap/Modal";
import { createNewFeedback } from "../Store/Actions/EnquiryActions";

function Feedback() {
	const [show, setShow] = useState(false);

	const [state, setState] = useState({
		name: "",
		mobileNumber: "",
		email: "",
		message: "",
	});

	const [rating, setRating] = useState(0);
	const [hoveredRating, setHoveredRating] = useState(0);

	const dispatch = useDispatch();

	const stateObject = useSelector((state) => state.enquiry);

	const onChangeHandler = (e) => {
		setState({ ...state, [e.target.name]: e.target.value });
	};

	let errors = [];
	if (typeof stateObject.errors !== "undefined") {
		stateObject.errors.map((item) => (errors[item.param] = item.msg));
	}

	const submitForm = (e) => {
		e.preventDefault();

		const data = { ...state, rating };
		dispatch(createNewFeedback(data));
	};

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	return (
		<>
			<Button
				onClick={handleShow}
				variant="default"
				className=" !bg-gradient-to-r !from-pink-500 !to-purple-500 !text-white py-2 !rounded-2xl !font-bold hover:!shadow-lg !transform hover:!scale-105 !transition-all !duration-300"
			>
				Submit New Feedback
			</Button>

			<Modal show={show} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>
						Submit Feedback
						<div className="text-center mt-2 text-sm font-semibold">
							We value your feedback! Please share your thoughts.
						</div>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={submitForm}>
						<div className="grid grid-cols-1 gap-2">
							<div className="bg-white rounded-3xl px-4 py-2 shadow-xl">
								{/* Personal Information */}
								<div className="grid grid-cols-1 md:grid-cols-1 gap-4">
									<div className="space-y-2">
										<label
											className="block !text-sm font-medium !text-gray-700 mb-2"
											htmlFor="name"
										>
											Name *
										</label>
										<input
											name="name"
											id="name"
											placeholder="Your full name"
											required
											onChange={onChangeHandler}
											className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
										/>
									</div>
									<div className="space-y-2">
										<label
											className="block !text-sm font-medium !text-gray-700 mb-2"
											htmlFor="email"
										>
											Email
										</label>
										<input
											name="email"
											id="email"
											type="text"
											placeholder="your.email@example.com (Optional)"
											required
											onChange={onChangeHandler}
											className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
										/>
									</div>

									{/* Rating */}
									<div className="space-y-3">
										<label className="block !text-sm font-medium !text-gray-700 mb-2">
											Overall Rating
										</label>
										<div className="flex items-center space-x-1">
											{[1, 2, 3, 4, 5].map((star) => (
												<button
													key={star}
													type="button"
													className="p-1"
													onMouseEnter={() =>
														setHoveredRating(star)
													}
													onMouseLeave={() =>
														setHoveredRating(0)
													}
													onClick={() =>
														setRating(star)
													}
												>
													<Star
														className={`w-6 h-6 ${
															star <=
															(hoveredRating ||
																rating)
																? "fill-yellow-400 text-yellow-400"
																: "text-gray-300"
														}`}
													/>
												</button>
											))}
											<span className="ml-2 text-sm text-gray-600">
												{rating > 0 &&
													`${rating} out of 5 stars`}
											</span>
										</div>
									</div>

									{/* Subject */}
									<div className="space-y-2">
										<label
											htmlFor="subject"
											className="block !text-sm font-medium !text-gray-700 mb-2"
										>
											Subject *
										</label>
										<input
											name="subject"
											id="subject"
											placeholder="Brief summary of your feedback"
											required
											onChange={onChangeHandler}
											className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
										/>
									</div>

									{/* Detailed Feedback */}
									<div className="space-y-4">
										<label
											htmlFor="message"
											className="block !text-sm font-medium !text-gray-700 mb-2"
										>
											Detailed Feedback *
										</label>
										<textarea
											name="message"
											id="message"
											placeholder="Please provide detailed information about your feedback..."
											required
											onChange={onChangeHandler}
											className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
										/>
									</div>

									<Button
										variant="default"
										type="submit"
										className="!w-full my-4 !bg-gradient-to-r !from-pink-500 !to-purple-500 !text-white py-3 !rounded-2xl !font-bold hover:!shadow-lg !transform hover:!scale-105 !transition-all !duration-300"
									>
										{stateObject.PROCESSING
											? "Submitting..."
											: "Submit 📨"}
									</Button>
									<div className="text-center">
										{stateObject.REQUEST_SUCCESS &&
											stateObject.message && (
												<div className="bg-gradient-to-r from-green-400 via-green-500 to-green-700 text-white rounded-2xl px-4 py-2 shadow-lg">
													{stateObject.message}
												</div>
											)}
										{stateObject.REQUEST_FAILED && (
											<div className="bg-red-400 text-white rounded-xl px-4 py-2 shadow-lg">
												{stateObject.message ||
													"Failed to submit feedback."}
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</Form>
				</Modal.Body>
			</Modal>
		</>
	);
}

export default Feedback;
